import { EnterpriseContextInterface } from './EnterpriseInterface';

export const enterpriseInitialState: EnterpriseContextInterface = {
  selectedEnterprise: undefined,
  availableEnterprise: [],
  isManagingEnterprise: false,
  enterpriseToDelete: undefined,
};
